module.exports = __webpack_public_path__ + "static/media/door_opened.9fac2295.png";